// src/mazot-takip/src/pages/MazotListesi.js
import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { db } from "../firebaseConfig";
import { collection, getDocs, query, where, addDoc, serverTimestamp } from "firebase/firestore";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import "dayjs/locale/tr";

dayjs.locale("tr");

/* ======================= HELPERS ======================= */
const norm = (v) => String(v ?? "").toUpperCase().replace(/\s+/g, " ").trim();
const toYMD = (ts) => {
  if (!ts) return "";
  if (ts.toDate) return dayjs(ts.toDate()).format("YYYY-MM-DD");
  return dayjs(ts).format("YYYY-MM-DD");
};
const toNum = (v) => (Number.isFinite(Number(v)) ? Number(v) : null);
const filterKey = (v) => String(v ?? "");

/* ======================= KOLONLAR ======================= */
const COLUMNS = {
  recordType: "Kayıt Türü",
  date: "Tarih",
  tesis: "Tesis",
  vehiclePlate: "Plaka",
  aracCinsi: "Araç Cinsi",
  tank: "Tank",
  driverName: "Şoför",
  liters: "Litre",
  odometerKm: "KM",
  deltaKm: "Fark KM",
  hour1: "Araç Saati",
  deltaH1: "Saat Farkı",
  hour2: "Makine Saati",
  deltaH2: "M. Saati Farkı",
  receiptNo: "Fiş / Fatura No",
  note: "Açıklama",
  createdBy: "Giren",
};

const NUMERIC = ["liters", "odometerKm", "deltaKm", "hour1", "deltaH1", "hour2", "deltaH2"];

const DATE_PRESETS = [
  { key: "BU_AY", label: "Bu Ay" },
  { key: "SON_7", label: "Son 7 Gün" },
  { key: "GECEN_AY", label: "Geçen Ay" },
  { key: "BU_YIL", label: "Bu Yıl" },
  { key: "GECEN_YIL", label: "Geçen Yıl" },
];

export default function MazotListesi() {
  const [rows, setRows] = useState([]);
  const [visibleCols, setVisibleCols] = useState(
    Object.keys(COLUMNS).filter((c) => !["tank", "createdBy"].includes(c))
  );

  const [filters, setFilters] = useState({});
  const [openFilter, setOpenFilter] = useState(null);
  const [filterSearch, setFilterSearch] = useState("");
  const [sortedBy, setSortedBy] = useState({ col: null, asc: true });

  const filterRef = useRef(null);
  const [filterPos, setFilterPos] = useState({ top: 0, left: 0, width: 220 });

  const [startDate, setStartDate] = useState(dayjs().startOf("month").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [preset, setPreset] = useState("BU_AY");
// --- TASARIM STATE'LERİ ---
  const [designs, setDesigns] = useState([]);
  const [selectedDesignId, setSelectedDesignId] = useState("");
  const [reportName, setReportName] = useState("");

  // Tasarımları Veritabanından Çek
  useEffect(() => {
    const fetchDesigns = async () => {
      try {
        const q = query(collection(db, "reportDesigns"), where("module", "==", "mazot"));
        const snap = await getDocs(q);
        const list = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setDesigns(list.sort((a, b) => (a.name || "").localeCompare(b.name || "", "tr")));
      } catch (e) { console.error("Tasarımlar yüklenemedi:", e); }
    };
    fetchDesigns();
  }, []);

  // Tasarımı Veritabanına Kaydet
const handleSaveDesign = async () => {
    if (!reportName.trim()) return alert("Lütfen tasarım adı girin!");
    try {
      const payload = {
        name: reportName.trim(),
        module: "mazot",
        columns: visibleCols,
        datePreset: preset, // Mevcut preset bilgisini ekledik
        startDate: startDate, // Başlangıç tarihini ekledik
        endDate: endDate,     // Bitiş tarihini ekledik
        createdAt: serverTimestamp(),
      };
      const docRef = await addDoc(collection(db, "reportDesigns"), payload);
      setDesigns(prev => [...prev, { id: docRef.id, ...payload }].sort((a, b) => a.name.localeCompare(b.name, "tr")));
      setReportName("");
      alert("Tasarım kaydedildi!");
    } catch (e) { console.error(e); alert("Hata oluştu!"); }
  };

  // Seçilen Tasarımı Uygula
const applyDesign = (id) => {
    setSelectedDesignId(id);
    const d = designs.find(x => x.id === id);
    if (!d) return;

    // Kolonları uygula
    if (d.columns) setVisibleCols(d.columns);

    // Tarih ayarlarını uygula
    if (d.datePreset && d.datePreset !== "OZEL") {
      applyPreset(d.datePreset); // Dinamik tarihi (Bu Ay, Geçen Ay vb.) hesapla
    } else {
      if (d.startDate) setStartDate(d.startDate);
      if (d.endDate) setEndDate(d.endDate);
      setPreset("OZEL");
    }
  };
  useEffect(() => {


  const handleSaveDesign = async () => {
    if (!reportName.trim()) return alert("Lütfen tasarım adı girin!");
    try {
      const payload = {
        name: reportName.trim(),
        module: "mazot",
        columns: visibleCols,
        createdAt: serverTimestamp(),
      };
      const docRef = await addDoc(collection(db, "reportDesigns"), payload);
      setDesigns(prev => [...prev, { id: docRef.id, ...payload }].sort((a, b) => a.name.localeCompare(b.name, "tr")));
      setReportName("");
      alert("Tasarım kaydedildi!");
    } catch (e) { console.error(e); alert("Hata oluştu!"); }
  };

  const applyDesign = (id) => {
    setSelectedDesignId(id);
    const d = designs.find(x => x.id === id);
    if (d && d.columns) setVisibleCols(d.columns);
  };

    const onDown = (e) => {
      if (filterRef.current && !filterRef.current.contains(e.target)) {
        setOpenFilter(null);
        setFilterSearch("");
      }
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  const applyPreset = (p) => {
    const n = dayjs();
    let s = "", e = n.format("YYYY-MM-DD");
    if (p === "BU_AY") s = n.startOf("month").format("YYYY-MM-DD");
    else if (p === "SON_7") s = n.subtract(6, "day").format("YYYY-MM-DD");
    else if (p === "GECEN_AY") {
      const m = n.subtract(1, "month");
      s = m.startOf("month").format("YYYY-MM-DD");
      e = m.endOf("month").format("YYYY-MM-DD");
    } else if (p === "BU_YIL") s = n.startOf("year").format("YYYY-MM-DD");
    else if (p === "GECEN_YIL") {
      const y = n.subtract(1, "year");
      s = y.startOf("year").format("YYYY-MM-DD");
      e = y.endOf("year").format("YYYY-MM-DD");
    }
    setStartDate(s); setEndDate(e); setPreset(p);
  };

  useEffect(() => {
    (async () => {
      const tankSnap = await getDocs(collection(db, "fuel_tanks"));
      const tankMap = {};
      tankSnap.docs.forEach((d) => {
        const t = d.data() || {};
        tankMap[d.id] = t.name || t.tankAdi || "";
      });

      const plateSnap = await getDocs(collection(db, "plates"));
      const plateMap = {};
      plateSnap.docs.forEach((d) => {
        const p = d.data() || {};
        if (p.plate) plateMap[norm(p.plate)] = p.aracCinsi || "";
      });

      const all = [];
      const txSnap = await getDocs(collection(db, "fuel_transactions"));
      txSnap.docs.forEach((d) => {
        const x = d.data() || {};
// Sadece true değil, "true" metnini de kontrol et
if (x.deleted === true || x.deleted === "true") return;
        const pStr = norm(x.vehiclePlate);
        all.push({
          _id: `tx:${d.id}`,
          recordType: "Dolum",
          date: toYMD(x.date),
          tesis: x.tesis || "",
          vehiclePlate: x.vehiclePlate || "",
          aracCinsi: plateMap[pStr] || "",
          tank: tankMap[x.tankId] || "",
          driverName: x.driverName || "",
          liters: Number(x.liters || 0),
          odometerKm: x.odometerKm ?? "",
          receiptNo: x.receiptNo || "",
          note: x.note || x.notes || "",
          deltaKm: "",
          hour1: x.hour1 ?? "",
          deltaH1: "",
          hour2: x.hour2 ?? "",
          deltaH2: "",
          createdBy: x.createdBy || "",
        });
      });

      const delSnap = await getDocs(collection(db, "fuel_deliveries"));
      delSnap.docs.forEach((d) => {
        const x = d.data() || {};
        all.push({
          _id: `del:${d.id}`,
          recordType: "İkmal",
          date: toYMD(x.date),
          tesis: x.tesis || "",
          vehiclePlate: "",
          aracCinsi: "",
          tank: x.tankName || tankMap[x.tankId] || "",
          driverName: "",
          liters: Number(x.liters || 0),
          odometerKm: "",
          receiptNo: x.invoiceNumber || "",
          note: x.notes || x.note || "",
          deltaKm: "",
          hour1: "",
          deltaH1: "",
          hour2: "",
          deltaH2: "",
          createdBy: x.createdBy || "",
        });
      });

      const adjSnap = await getDocs(collection(db, "fuel_tank_adjustments"));
      adjSnap.docs.forEach((d) => {
        const x = d.data() || {};
        all.push({
          _id: `adj:${d.id}`,
          recordType: "Tank Sıfırlama",
          date: toYMD(x.date),
          tesis: x.tesis || "",
          vehiclePlate: "",
          aracCinsi: "",
          tank: x.tankName || tankMap[x.tankId] || "",
          driverName: "",
          liters: Number(x.deltaLiters || 0),
          odometerKm: "",
          receiptNo: "",
          note: x.note || x.notes || "",
          deltaKm: "",
          hour1: "",
          deltaH1: "",
          hour2: "",
          deltaH2: "",
          createdBy: x.createdBy || "",
        });
      });

      setRows(all.filter((r) => r.date));
    })();
  }, []);

  const deltaById = useMemo(() => {
    const map = new Map();
    const dolum = rows
      .filter((r) => r.recordType === "Dolum" && r.vehiclePlate && toNum(r.odometerKm) != null)
      .map((r) => ({ id: r._id, plate: r.vehiclePlate, date: r.date, km: toNum(r.odometerKm) }));

    const byPlate = {};
    dolum.forEach((r) => {
      if (!byPlate[r.plate]) byPlate[r.plate] = [];
      byPlate[r.plate].push(r);
    });

    Object.values(byPlate).forEach((arr) => {
      arr.sort((a, b) => a.date.localeCompare(b.date));
      arr.forEach((r, i) => {
        map.set(r.id, i === 0 ? "" : r.km - arr[i - 1].km);
      });
    });
    return map;
  }, [rows]);

  const dateFilteredRows = useMemo(() => {
    return rows.filter((r) => {
      if (startDate && r.date < startDate) return false;
      if (endDate && r.date > endDate) return false;
      return true;
    });
  }, [rows, startDate, endDate]);

  const filtered = useMemo(() => {
    const base = dateFilteredRows.filter((r) => {
      return Object.entries(filters).every(([k, arr]) => {
        if (!Array.isArray(arr)) return true;
        return arr.includes(filterKey(r[k]));
      });
    });

    let list = base.map((r) => ({
      ...r,
      deltaKm: r.recordType === "Dolum" ? deltaById.get(r._id) ?? "" : "",
    }));

    if (sortedBy.col) {
      list.sort((a, b) => {
        let vA = a[sortedBy.col] ?? "";
        let vB = b[sortedBy.col] ?? "";
        if (NUMERIC.includes(sortedBy.col)) {
          return sortedBy.asc ? Number(vA) - Number(vB) : Number(vB) - Number(vA);
        }
        return sortedBy.asc ? String(vA).localeCompare(String(vB), "tr") : String(vB).localeCompare(String(vA), "tr");
      });
    }
    return list;
  }, [dateFilteredRows, filters, deltaById, sortedBy]);

  const totals = useMemo(() => {
    const t = {};
    Object.keys(COLUMNS).forEach((k) => (t[k] = ""));
    NUMERIC.forEach((k) => {
      t[k] = filtered.reduce((a, r) => a + (Number(r[k]) || 0), 0);
    });
    t.recordType = "TOPLAM";
    return t;
  }, [filtered]);

  const isColumnFiltered = (col) => Array.isArray(filters[col]);

  const FilterArrow = ({ active, onClick }) => (
    <span onClick={onClick} style={{ marginLeft: 4, cursor: "pointer", color: active ? "#2563eb" : "#475569" }}>▾</span>
  );

  const renderFilterDropdown = (col) => {
    const values = Array.from(new Set(dateFilteredRows.map(r => filterKey(r[col]))))
      .filter(o => norm(o).includes(norm(filterSearch)))
      .sort((a, b) => String(a).localeCompare(String(b), "tr"));

    const allValues = Array.from(new Set(dateFilteredRows.map(r => filterKey(r[col]))))
      .sort((a, b) => String(a).localeCompare(String(b), "tr"));
    const selected = Array.isArray(filters[col]) ? filters[col] : allValues;
    const isAllSelected = values.length > 0 && values.every(v => selected.includes(v));

    return ReactDOM.createPortal(
      <div ref={filterRef} style={{ position: "fixed", top: filterPos.top, left: filterPos.left, width: filterPos.width, background: "#fff", border: "1px solid #93c5fd", padding: 8, zIndex: 9999, borderRadius: 4, boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}>
        <button 
          onClick={() => setSortedBy(p => ({ col, asc: p.col === col ? !p.asc : true }))}
          style={{ width: "100%", padding: 6, marginBottom: 8, cursor: "pointer", fontWeight: "bold", background: "#f1f5f9", border: "1px solid #cbd5e1", borderRadius: 4 }}
        >
          {sortedBy.col === col && !sortedBy.asc ? "↓ Z'den A'ya Sırala" : "↑ A'dan Z'ye Sırala"}
        </button>

        <input placeholder="Ara..." value={filterSearch} onChange={(e) => setFilterSearch(e.target.value)} style={{ width: "100%", marginBottom: 8, padding: 4, boxSizing: "border-box" }} />
        
        {/* TÜMÜNÜ SEÇ / KALDIR SATIRI */}
        <label style={{ display: "flex", alignItems: "center", marginBottom: 8, paddingBottom: 6, borderBottom: "1px solid #eee", fontWeight: "bold", fontSize: 12, cursor: "pointer" }}>
            <input 
                type="checkbox" 
                checked={isAllSelected} 
                onChange={() => {
                    if (isAllSelected) {
                        setFilters(p => ({ ...p, [col]: allValues.filter(v => !values.includes(v)) }));
                    } else {
                        const next = Array.from(new Set([...selected, ...values]));
                        setFilters(p => ({ ...p, [col]: next.length === allValues.length ? undefined : next }));
                    }
                }} 
            />
            <span style={{ marginLeft: 6 }}>Tümünü Seç / Kaldır</span>
        </label>

        <div className="ml-filter-options">
          {values.map(opt => (
            <label key={opt} style={{ display: "flex", alignItems: "center", marginBottom: 4, fontSize: 12, cursor: "pointer" }}>
              <input type="checkbox" checked={selected.includes(opt)} onChange={() => {
                const next = selected.includes(opt) ? selected.filter(v => v !== opt) : [...selected, opt];
                setFilters(p => ({ ...p, [col]: next.length === allValues.length ? undefined : next }));
              }} /> 
              <span style={{ marginLeft: 6 }}>{opt || "(boş)"}</span>
            </label>
          ))}
        </div>
        <button onClick={() => setFilters(p => ({ ...p, [col]: undefined }))} style={{ width: "100%", marginTop: 8 }}>Temizle</button>
      </div>,
      document.body
    );
  };

  const exportExcel = () => {
    const out = filtered.map((r) => {
      const o = {};
      visibleCols.forEach((c) => (o[COLUMNS[c]] = r[c]));
      return o;
    });
    const ws = XLSX.utils.json_to_sheet(out);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "MazotListesi");
    XLSX.writeFile(wb, "mazot_listesi.xlsx");
  };

  return (
    <div style={{ padding: 10 }}>
      <style>{`
        .ml-filter-btn{ width:22px; height:20px; border:1px solid #cbd5e1; border-radius:6px; background:linear-gradient(#fff,#f1f5f9); color:#334155; cursor:pointer; font-size:12px; line-height:16px; padding:0; margin-left:4px; box-shadow:0 1px 1px rgba(15,23,42,.08); }
        .ml-filter-btn:hover,.ml-filter-btn.active{ background:#dbeafe; border-color:#60a5fa; color:#1d4ed8; }
        .ml-filter-options{ max-height:180px; overflow-y:auto; border:1px solid #e5e7eb; border-radius:6px; padding:6px; background:#f8fafc; }
      `}</style>
      {/* ÜST TASARIM PANELİ (Fatura Listesi Tarzı) */}

      <div style={{ display: "flex", gap: 14, alignItems: "flex-start", marginBottom: 8 }}>
        <div style={{ width: 190 }}>
          {/* ALANLAR KUTUSU - Punto 12px yapıldı */}
          <div style={{ border: "1px solid #cbd5e1", padding: 6, maxHeight: 190, overflowY: "auto", fontSize: 12 }}>
            <div style={{ fontWeight: "bold", marginBottom: 4 }}>Alanlar:</div>

            
{Object.keys(COLUMNS).map((col) => {
              const isFiltered = isColumnFiltered(col);
              
              return (
                <div 
                  key={col} 
                  style={{ 
                    display: "flex", 
                    alignItems: "center", 
                    marginBottom: 3,
                    padding: "4px 8px",
                    borderRadius: "6px",
                    fontSize: "12px",
                    // 🎯 FaturaListesi Soft Renkleri
                    backgroundColor: isFiltered ? "#dbeafe" : "transparent", 
                    border: isFiltered ? "1px solid #bfdbfe" : "1px solid transparent",
                    transition: "all 0.2s ease"
                  }}
                >
                  <input
                    type="checkbox"
                    checked={visibleCols.includes(col)}
                    style={{ cursor: "pointer" }}
                    onChange={() => setVisibleCols((p) => (p.includes(col) ? p.filter((c) => c !== col) : [...p, col]))}
                  />
                  <span style={{ 
                    marginLeft: 10, 
                    flex: 1, 
                    cursor: "default",
                    // Yazı rengi filtre varken koyu mavi (daha soft durur)
                    color: isFiltered ? "#1e40af" : "#334155",
                    fontWeight: isFiltered ? "600" : "400"
                  }}>
                    {COLUMNS[col]}
                  </span>
                  <FilterArrow 
                    active={isFiltered} 
                    isFiltered={isFiltered} // Soft görünüm için gönderdik
                    onClick={(e) => {
                      const r = e.currentTarget.getBoundingClientRect();
                      setFilterPos({ top: r.bottom + 4, left: r.left, width: 220 });
                      setOpenFilter(col);
                    }} 
                  />

                  
                </div>

                
              );
            })}

            
          </div>
        </div>

<div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 10 }}>
          {/* ÜST SATIR: TARİH SEÇİM ALANI */}
          <div style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 12 }}>
            <b>Tarih:</b>
            <select value={preset} onChange={(e) => applyPreset(e.target.value)} style={{ padding: "2px 4px" }}>
              {DATE_PRESETS.map((p) => <option key={p.key} value={p.key}>{p.label}</option>)}
            </select>
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} style={{ padding: "2px 4px" }} />
            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} style={{ padding: "2px 4px" }} />
          </div>

          {/* ALT SATIR: TASARIM PANELİ */}
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 12, fontWeight: "bold" }}>Tasarım:</span>
            <select 
              value={selectedDesignId} 
              onChange={(e) => applyDesign(e.target.value)}
              style={{ padding: "4px 8px", borderRadius: "6px", border: "1px solid #cbd5e1", fontSize: 12, minWidth: 200, background: "#f8fafc" }}
            >
              <option value="">-- Kayıtlı Tasarım Seç --</option>
              {designs.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
            </select>
            
            <input 
              type="text" 
              placeholder="Yeni Tasarım Adı..." 
              value={reportName} 
              onChange={e => setReportName(e.target.value)}
              style={{ padding: "4px 8px", borderRadius: "6px", border: "1px solid #cbd5e1", fontSize: 12, width: 180 }}
            />
            
            <button 
              onClick={handleSaveDesign}
              style={{ background: "#2563eb", color: "white", padding: "5px 15px", borderRadius: "6px", cursor: "pointer", border: "none", fontSize: 12, fontWeight: "500" }}
            >
              Kaydet
            </button>
          </div>
        </div>

        <div>
          <button onClick={exportExcel} style={{ background: "#22c55e", color: "#fff", padding: "6px 10px", border: "none", fontSize: 12, cursor: "pointer", borderRadius: 4 }}>
            Excel'e Aktar
          </button>
        </div>
      </div>

      <div style={{ overflowX: "auto" }}>
        <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 12 }}>
          <thead style={{ background: "#f8fafc" }}>
            <tr>
              {visibleCols.map((col) => (
                <th key={col} style={{ 
    border: "1px solid #cbd5e1", 
    padding: 6, 
    whiteSpace: "nowrap", 
    textAlign: "left",
    color: isColumnFiltered(col) ? "#1d4ed8" : "inherit", // Daha koyu bir mavi
    backgroundColor: isColumnFiltered(col) ? "#eff6ff" : "#f8fafc" // Hafif mavi arka plan
}}>
                  {COLUMNS[col]}
                  <FilterArrow active={isColumnFiltered(col)} onClick={(e) => {
                    const r = e.currentTarget.getBoundingClientRect();
                    setFilterPos({ top: r.bottom + 4, left: r.left, width: 220 });
                    setOpenFilter(col);
                  }} />
                </th>
              ))}
            </tr>
            <tr style={{ background: "#e5e7eb", fontWeight: "bold" }}>
              {visibleCols.map((col) => (
                <td key={col} style={{ border: "1px solid #cbd5e1", padding: 6 }}>
                  {NUMERIC.includes(col) ? (Number(totals[col]) || 0).toLocaleString("tr-TR") : totals[col]}
                </td>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={r._id}>
                {visibleCols.map((c) => <td key={c} style={{ border: "1px solid #cbd5e1", padding: 6 }}>{r[c]}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {openFilter && renderFilterDropdown(openFilter)}
    </div>
  );
}
